// extracted by mini-css-extract-plugin
export default {"top_logo":"index_top_logo_pQ1WO"};